// KONFIGURATIONSDATEI
// Hier werden wichtige Konfigurationsvariablen definiert.
const config = {
    // Domain noch festlegen
    domain: "http://fairmoegenskompass.de/",
    
  };
  
  export default config;
  